import type { FirestoreEntity, IsoDate, Summary, VatRateDecimal, WithId } from './entities';

export type VatRateType = 'standardRate' | 'reducedRate' | 'specialRate' | 'none';

export const VAT_RATE_TEXTS: Record<VatRateType, string> = {
  standardRate: 'Normalsatz',
  reducedRate: 'Reduzierter Satz',
  specialRate: 'Spezialsatz',
  none: 'Keine Mehrwertsteuer',
};

export function getVatRateForDropdown(): Summary[] {
  return Object.entries(VAT_RATE_TEXTS).reduce(
    (prev, cur) => [...prev, { id: cur[0], displayName: cur[1] }],
    [] as Summary[]
  );
}

/*
Das sieht dann zum Beispiel so aus:  das typing kann ja niemand lesen...
{
  "reducedRate": "0.026",
  "specialRate": "0.037",
  "standardRate": "0.081",
  "validFrom": "2024-01-01",
  "validTo": "2029-12-31"
}
*/
export interface VatRateEntity extends Record<Exclude<VatRateType, 'nome'>, VatRateDecimal> {
  validFrom: IsoDate;
  validTo: IsoDate;
}

export type VatRate = VatRateEntity & WithId;

export type FirestoreVatRate = FirestoreEntity<VatRateEntity>;
